export const RoundButton = ({ color, handleClick, selected }: any) => (
  <button
    type="button"
    aria-label={color}
    aria-pressed={selected}
    // relative + an invisible ::before hit-area (same technique as the
    // checkbox/switch touch-target growth in index.css) brings this 32px
    // swatch up to the 44px mobile touch-target floor (design-system.md
    // section 8) without growing the visible circle.
    className={`relative w-8 h-8 rounded-full inline-block m-1 transition-all before:content-[''] before:absolute before:-inset-1.5 ${
      selected ? "ring-2 ring-gray-500 ring-offset-1" : ""
    }`}
    style={{ backgroundColor: color }}
    onClick={handleClick}
  />
);
